module.exports = __webpack_public_path__ + "img/radis.76182e83.jpg";